(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["float-button-whatsapp"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.sgWhatsappSelectorReady) return;
  var root = document.querySelector('[data-sg-wa-root]');
  var dialog = document.getElementById('sg-wa-dialog');
  if (!root || !dialog) return;
  window.sgWhatsappSelectorReady = true;
  var phone = (root.getAttribute('data-phone') || '').replace(/\D/g, '');
  var trigger = null;
  var sent = false;
  var key = 'sg_whatsapp_service_selected_v1';
  function matchesContact(link) {
    if (!link) return false;
    try {
      var url = new URL(link.href, location.href);
      if (url.hostname === 'wa.me') return url.pathname.replace(/\D/g, '') === phone;
      return /^(api|web)\.whatsapp\.com$/.test(url.hostname) && (url.searchParams.get('phone') || '').replace(/\D/g, '') === phone;
    } catch (error) { return false; }
  }
  function openSelector(source) {
    trigger = source;
    if (!dialog.open) dialog.showModal();
  }
  function closeSelector() {
    dialog.close();
    if (trigger && trigger.isConnected) trigger.focus();
  }
  root.querySelector('.sg-wa-launch').addEventListener('click', function (event) { openSelector(event.currentTarget); });
  root.querySelector('[data-sg-wa-close]').addEventListener('click', closeSelector);
  dialog.addEventListener('click', function(event) {
    if (event.target === dialog) {
      var rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeSelector();
    }
  });
  document.addEventListener('click', function(event) {
    if (!event.target || !event.target.closest) return;
    var option = event.target.closest('[data-sg-wa-service]');
    if (option && root.contains(option)) {
      var service = option.getAttribute('data-sg-wa-service');
      if (!/^(trajes|camisas|otros)$/.test(service)) return;
      var prior = sent;
      try { prior = prior || sessionStorage.getItem(key) === '1'; } catch(error) {}
      if (!prior) {
        sent = true;
        try { sessionStorage.setItem(key, '1'); } catch(error) {}
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'whatsapp_service_selected',
          service: service,
          contact_channel: 'whatsapp',
          contact_stage: 'service_selected',
          page_path: location.pathname
        });
      }
      window.open(option.getAttribute('data-sg-wa-url'), '_blank', 'noopener,noreferrer');
      return;
    }
    var link = event.target.closest('a[href]');
    if (matchesContact(link)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openSelector(link);
    }
  }, true);
})();

  } catch(e) { console.error(e); }
})();
})();
